import "./App.scss";
import AppRoutes from "./screens/routes";
import "./shared/oversight-core/bootstrap/bootstrap.scss";

function App() {
  return <AppRoutes />;
}

export default App;
